import React from 'react';
import { Link as RouterLink } from "react-router-dom";
import "../Styles/Getmydata.css";
import LinkImage from "../Assets/FileReceived.png";

function Getmydata() {
  return (
    <div className="data-instructions">
      <div className="data-header-intro">
        <span className="data-header-text">
          As a BeReal user, you can request your complete usage history, including all posts and comments, directly from the app. 
          Once requested, BeReal will send a download link to your data via the in-app message center.
        </span>
      </div>

      <div className="data-step-container">
        <div className="step-title">Step 1: Navigate to Request Form</div>
        <div className="step-text">
          Open the BeReal app → Tap your profile icon → Tap the <strong>gear icon</strong> in the top-right corner to enter settings.<br />
          Then under the "About" section click on <strong>Help → Contact Us → Ask a Question → Troubleshooting → Other → Still need help?</strong>
        </div>

        <div className="step-title">Step 2: Request Your Data</div>
        <div className="step-text">
          In the “Get in touch” screen, tap the "Select a Topic" field and choose:<br />
          <strong>"I'd like to request a copy of my data"</strong><br />
          Fill out the rest of the form (if required) and tap <strong>Send</strong>.
        </div>

        <div className="step-title">Step 3: Wait for a Response</div>
        <div className="step-text">
          BeReal will reply to your message in-app (under Contact Us → Messages) within a day or so, including a download link.
        </div>
        
        <img src={LinkImage} alt="Download link from BeReal" className="data-image" />
        <div className="step-title">
          Step 4: Download the File</div>
        <div className="step-text">
          Click the link and download the .zip file within 24 hours. 
          <br /><br />
          <span className="highlight">
            You’re now ready to create your timelapse! Simply upload the zip file—no need to unzip it.
          </span>
        </div>
      </div>

      <RouterLink to="/upload/u2">
        <button className="upload-nav-button">Upload Your Data Here!</button>
      </RouterLink>
    </div>
  );
}

export default Getmydata;
